import { TextStyle } from '@hh.ru/magritte-ui';
import { SalaryRange } from '@hh.ru/types-hh-microcore';

export const getTextStyle = (salaryRange: SalaryRange, hasSalaryAdvice: boolean): TextStyle => {
    if (!hasSalaryAdvice && salaryRange === SalaryRange.MatchMarket) {
        return 'positive';
    }
    if ([SalaryRange.MatchMarket, SalaryRange.TooWide].includes(salaryRange)) {
        return 'warning';
    }
    if ([SalaryRange.High, SalaryRange.TooHigh].includes(salaryRange)) {
        return 'special';
    }
    return 'negative';
};
